import * as Actions from './BookingContainerActions';

const defaultState = {
    showSecureHeader: true,
    showModal: false,
    modalContent: undefined,
    timeout: null,
};

export const bookingContainerReducer = (state = defaultState, action) => {
    switch (action.type) {
        case Actions.BookingContainerActions.SHOW_SECURE_HEADER: {
            return {
                ...state,
                showSecureHeader: action.showSecureHeader,
            };
        }

        case Actions.BookingContainerActions.SHOW_MODAL: {
            if (state.showModal) {
                return state;
            } else {
                return {
                    ...state,
                    modalContent: action.modalContent,
                    showModal: true,
                };
            }
        }

        case Actions.BookingContainerActions.HIDE_MODAL: {
            return {
                ...state,
                showModal: false,
            };
        }

        default:
            return state;
    }
};
